<template>
  <div class='myClient'>
    <!-- 筛选 -->
    <filter-panel style="width: 100%"
                  :data="group"
                  :hideResult="true"
                  @search="filterChange"></filter-panel>

    <!-- 列表 -->
    <data-list :table-style="{ name: 'mixture' }"
               :data="data"
               :hint="hint"
               :columns="columns"
               :page="page"
               :loading="loading"
               @page-size-changed="pageSizeChanged"
               @page-changed="pageChanged"></data-list>

    <!-- 编辑表单 -->
    <myClientEdit ref='myClientEdit'
                  dialogWidth="550px"
                  title="编辑"></myClientEdit>
  </div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import myClientEdit from './form/myClientEdit.vue';
import customer from '@/mixins/customer';

import api from '@/backend/apiConfig/apiConfig'

const page = listPageCreate({
  searchConfig: {
    api: api.googleAds.templateRelationList,
    method: 'POST',
  },
  getQuery (obj, that) {
    let { searchType, searchValue } = obj
    switch (searchType) {
      case 0:
        obj.serviceCode = searchValue
        break;
      case 1:
        obj.cid = searchValue
        break;
      case 2:
        obj.domain = searchValue
        break;
      case 3:
        obj.serviceStaffName = searchValue
        break;
    }
    delete obj.searchType
    delete obj.searchValue
    return _.assign(obj);
  },
});

export default {
  name: 'myClient',
  components: {
    filterPanel,
    myClientEdit
  },
  mixins: [page, customer],
  data () {
    let self = this;
    return {
      hint: {
        content: '列表仅展示有效期内服务单的报告模板使用情况',
        style: {
          fontSize: '14px',
          color: '#EC808D',
          marginLeft: '15px',
        }
      },
      columns: [
        {
          label: '客户名称',
          bind: 'customerName'
        },
        {
          label: '服务单',
          bind: 'serviceCode'
        },
        {
          label: '主域名',
          bind: 'domain'
        },
        {
          label: '优化师',
          bind: 'serviceStaffName'
        },
        {
          label: 'CID',
          bind: 'cid'
        },
        {
          label: '自动月报',
          bind (data) {
            let { monthlyReportOpen, monthlyReportTemplateName } = data
            if (monthlyReportOpen) return monthlyReportTemplateName
            return '-'
          }
        },
        {
          label: '自动周报',
          bind (data) {
            let { weekReportOpen, weekReportTemplateName } = data
            if (weekReportOpen) return weekReportTemplateName
            return '-'
          }
        },
        {
          label: '操作',
          type: 'btnClick',
          style: 'text',
          bind: () => {
            return [
              {
                text: '编辑',
                showButton () {
                  return true
                },
                trigger: async row => {
                  let { cancel } = await self.$refs.myClientEdit.show(row)
                  if (!cancel) {
                    self.query()
                  }
                },
              },
            ];
          },
        },
      ],
      group: {
        others: [
          {
            tagName: 'sky-input-prepend',
            placeholder: '查询',
            label: '',
            prop: ['searchValue', 'searchType'],
            value: ['', 0],
            inputStyle: {
              width: '450px',
            },
            prepend: {
              options: [
                {
                  label: '服务单',
                  value: 0
                },
                {
                  label: 'CID',
                  value: 1
                },
                {
                  label: '主域名',
                  value: 2
                },
                {
                  label: '优化师',
                  value: 3
                },
              ],
              style: {
                width: '180px',
              }
            }
          },
        ],
      },
    }
  },
  mounted () {
    this.query()
  },
}
</script>
